// extracted by mini-css-extract-plugin
export var productImage = "_ob-1";
export var viewLink = "_ob-2";
export var wishlistItem = "_ob-0";